import React from "react";
function NavBar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark p-1 detail_navbar">
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav">
          <li className="nav-item active">
            <a className="nav-link" href="#about">
              About
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#schedule">
              Schedule
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#reviews">
              Reviews (1)
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#resume">
              Resume
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#subjects">
              Subject
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
